import axios from 'axios';
import { API_BASE_URL } from '../../config';

export const apiAxios = axios.create({
    baseURL: 'https://www.luxlifemiamirealestate.com/api/api',
});